export default __webpack_public_path__ + "13beb95e5762cf7343de0497fd401b04.svg";